import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import "./DashboardLayout.css";
import "./AkasCmsTheme.css";
import "./AkasMotion.css";

const DashboardLayout = ({ children }) => {
  const userProfile = useSelector((state) => state?.auth?.login?.profile);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const closeSidebar = useCallback(() => setIsSidebarExpanded(false), []);
  const toggleSidebar = useCallback(() => setIsSidebarExpanded((current) => !current), []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") closeSidebar();
    };
    document.body.classList.toggle("akas-sidebar-open", isSidebarExpanded);
    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.classList.remove("akas-sidebar-open");
      window.removeEventListener("keydown", handleEscape);
    };
  }, [closeSidebar, isSidebarExpanded]);

  return (
    <>
      <div className="page dashboard-layout akas-app-shell">
        <Sidebar
          userProfile={userProfile}
          isAreaExpanded={isSidebarExpanded}
          onCloseArea={closeSidebar}
        />
        <button
          type="button"
          className={`sidebar-drawer-backdrop ${isSidebarExpanded ? "is-visible" : ""}`}
          aria-label="Tutup navigasi"
          tabIndex={isSidebarExpanded ? 0 : -1}
          onClick={closeSidebar}
        />
        <Navbar
          userProfile={userProfile}
          isSidebarExpanded={isSidebarExpanded}
          onToggleSidebar={toggleSidebar}
        />
        {children}

        <Footer />
      </div>
    </>
  );
};

export default DashboardLayout;
